import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        const heroCatch = document.querySelector("#l-hero")
        if(heroCatch){
            const str_animation =  anime.timeline();
            str_animation
            .add({
                targets:"#hero--slider",
                opacity: [0,1],
                scale: [0.99,1],
                // translateY: ["-100px",0],
                easing: "easeOutBack",
                duration:1500,
            },1200)
            .add({
                targets:"#l-hero__address",
                opacity: [0,1],
                translateX: ["-20px",0],
                easing: "easeOutCirc",
                duration:800,
            },1800)
            .add({
                targets:"#l-hero__gnav",
                opacity: [0,1],
                translateX: ["-20px",0],
                easing: "easeOutCirc",
                duration:800,
            },2400)
            .add({
                targets:".l-hero__news--wrapper",
                opacity: [0,1],
                translateY: ["20px",0],
                easing: "easeOutCirc",
                duration:800,
            },3000)
            // .add({
            //     targets:".p-index__kv--sticker",
            //     opacity: [0,1],
            //     scale:[0.98,1],
            //     easing: "easeOutCirc",
            //     duration:800,
            // },"-=600")
            // .add({
            //     targets:".p-index__kv--img",
            //     opacity: [0,1],
            //     // blur: ['50px',0],
            //     easing: "easeInExpo",
            //     duration:1500,
            // },"-=2500")
            // .add({
            //     targets : '.p-index__kv--catch-ja',
            //     opacity: [0,1],
            //     easing: "easeInQuart",
            //     duration:3000
            // },"-=3000")
        }
        
    }
}